// extracted by mini-css-extract-plugin
export var shake = "_5-0";